import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImpairmentCategory, TwoDimensionalAiAssessmentViewModelRead } from '../../_models/generatedModels';
import { Enums } from '../../_models/generatedEnums';

@Component({
  selector: 'category-details-popup',
  templateUrl: 'category-details-popup.component.html',
  styleUrls: ['public-two-dimensional-ai-result-details.component.scss']
})
export class CategoryDetailsPopupComponent implements OnInit {
  initialized = false;
  impairmentCategoryEnum = Enums.ImpairmentCategoryEnum;
  impairmentCategory = ImpairmentCategory;
  categoryScoreEnum = Enums.CategoryScoreEnum;

  @Input()
  category: ImpairmentCategory;

  @Input()
  analysis: TwoDimensionalAiAssessmentViewModelRead;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.initialized = true;
  }

  getCategoryDescription()
  {
    if (this.category == ImpairmentCategory.OverstriderGeneral)
      return "Overstriding creates braking forces which slow you down and increase stress on your joints and muscles. This occurs when your foot lands ahead of your body or when your landing position differs from side to side. Learning to land closer to your body and evenly will improve efficiency and reduce injury risk. Focus on the cues and corrective exercises provided to build safer mechanics and support your long term health.";
    else if (this.category == ImpairmentCategory.GeneralCadence)
      return "Cadence is the number of steps you take per minute while running. When your cadence is too low, each step places excessive stress on your body and can slow you down significantly. By increasing your cadence, you can reduce injury risk, improve efficiency, and unlock greater running performance.";
    else if (this.category == ImpairmentCategory.Bouncer)
      return "Bouncing occurs when there is excessive vertical movement compared to forward motion while running. This up-and-down motion slows you down, reduces efficiency, and adds unnecessary stress to your body. By focusing on reducing vertical motion, you can ease strain on your body and run more smoothly and efficiently.";
    else if (this.category == ImpairmentCategory.Collapser)
      return "Collapsing occurs when the ankle, knee, or hip rotate move excessively inward. This inward motion makes it hard for the body to absorb the stresses of running, increasing the likelihood of injury and reducing efficiency and speed. By improving posture and/or reducing time on the ground, you can protect your body, lower injury risk, and run more effectively.";
    else if (this.category == ImpairmentCategory.GluteAmnesiac)
      return "Glute Amnesiac occurs when there isn’t enough forward lean while running, which reduces activation of critical muscles for running(ex. glutes) and shifts more load to the front of the body. This imbalance can increase stress on other muscles and limit running power.By improving forward lean, you can activate the glutes more effectively and enhance both performance and efficiency.";
    else
      return "Performance Optimization applies when your running form shows no major deficiencies but can be fine-tuned for greater efficiency and power. Small adjustments in your mechanics can help you move more smoothly, conserve energy, and unlock your full performance potential. Use the individualized metrics, cues, and corrective exercises provided to sharpen your form and continue progressing toward your best running self.";
  }

  getCategoryImage()
  {
    if (this.category == ImpairmentCategory.OverstriderGeneral)
      return "overstrider-icon.png";
    else if (this.category == ImpairmentCategory.GeneralCadence)
      return "low-cadence-icon.png";
    else if (this.category == ImpairmentCategory.Bouncer)
      return "bouncer-icon.png";
    else if (this.category == ImpairmentCategory.Collapser)
      return "collapser-icon.png";
    else if (this.category == ImpairmentCategory.GluteAmnesiac)
      return "glute-amnesiac-icon.png";
    else "performance-optimization-icon.png";
      return
  }

  removeNegtiveSign(value: number): number
  {
    return Math.abs(value);
  }

  getLabelPelvicDrop(value: number, isLeft: boolean)
  {
    if (value < 0) {
      return isLeft ? 'lft up' : 'rgt up'
    }
    else {
      return isLeft ? 'lft down' : 'rgt down'
    }
  }

  getLabelForwardLean(value: number)
  {
    if (value < 0) {
      return 'ext'
    }
    else {
      return 'flex';
    }
  }

  getLabelHipAdduction(value: number)
  {
    if (value < 0) {
      return 'add'
    }
    else {
      return 'abd';
    }
  }

  getLabelTibialInclination(value: number)
  {
    if (value < 0) {
      return 'ext'
    }
    else {
      return 'flex';
    }
  }

  getLabelAnklePronatoin(value: number)
  {
    if (value < 0) {
      return 'sup'
    }
    else {
      return 'pron';
    }
  }

  getLabeCrossover(value: number)
  {
    if (value < 0) {
      return 'add'
    }
    else {
      return 'abd';
    }
  }

  getLabelFootInclination(value: number)
  {
    if (value < 0) {
      return 'DF'
    }
    else {
      return 'PL';
    }
  }

  overrideScore(scoreLevel: string)
  {
    if (scoreLevel == 'G')
      return "E";
    else if (scoreLevel == 'GF')
      return "G";

    return scoreLevel;
  }

}
